import loadable from "@loadable/component"
import { Box, CircularProgress } from "@mui/material"
import { RouteObject } from "react-router-dom"

import AuthLayout from "~/layout/auth-layout/AuthLayout"
import ProtectedAuthRoutes from "~/router/routes/auth/ProtectedAuthRoutes"
import { APP_ROUTES } from "~/shared/constants/routes"

const AuthRouteFallback = () => (
  <Box
    alignItems='center'
    display='flex'
    height='100%'
    justifyContent='center'
    width='100%'
  >
    <CircularProgress aria-label='در حال بارگذاری' />
  </Box>
)

const LoginPage = loadable(
  async () => import("~/features/auth/pages/LoginPage"),
  { fallback: <AuthRouteFallback /> },
)

export const authRoutes: RouteObject[] = [
  {
    element: <ProtectedAuthRoutes />,
    children: [
      {
        path: APP_ROUTES.home,
        element: <AuthLayout />,
        children: [{ path: APP_ROUTES.login, element: <LoginPage /> }],
      },
    ],
  },
]
